export const submittedFormLocalization = {
  downloadSubmittedApplication: {
    en: 'Download submitted application',
    nb: 'Last ned innsendt søknad',
    nn: 'Last ned innsend søknad',
  },
  attachmentsHeader: {
    en: 'Attachments to submitted form',
    nb: 'Vedlegg til innsendt skjema',
    nn: 'Vedlegg til innsend skjema',
  },
  dateHeaderLabel: {
    en: 'Submitted',
    nb: 'Sendt inn',
    nn: 'Sendt inn',
  },
  titleHeaderLabel: {
    en: 'Document',
    nb: 'Dokument',
    nn: 'Dokument',
  },
  detailsHeaderLabel: {
    en: 'Show',
    nb: 'Vis',
    nn: 'Vis',
  },
  submittedDateLabel: {
    en: 'Submitted',
    nb: 'Sendt inn',
    nn: 'Sendt inn',
  },
  confirmationsLabel: {
    en: 'Confirmations',
    nb: 'Bekreftelser',
    nn: 'Bekreftelsar',
  },
  submittedByLabel: {
    en: 'Submitted by',
    nb: 'Innsender',
    nn: 'Innsender',
  },
  deferralPaymentLabel: {
    en: 'Submitted invoice number',
    nb: 'Innsendt fakturanummer',
    nn: 'Innsendt fakturanummer',
  },
  pdfDisplayError: {
    en: 'Unable to render the application PDF',
    nb: 'Kunne ikke vise PDF av søknaden',
    nn: 'Kunne ikke vise PDF av søknaden',
  },

  // Form titles:
  'payout-request-grant-mentor-support': {
    nb: 'Utbetaling av støtte til mentor',
    nn: 'Utbetaling av støtte til mentor',
    en: 'Mentor support payout',
  },

  'payout-request-grant-simple': {
    nb: 'Utbetaling av tilskudd',
    nn: 'Utbetaling av tilskot',
    en: 'Grant payout',
  },

  'final-report-grant-simple': {
    nb: 'Sluttrapport for tilskudd',
    nn: 'Sluttrapport for tilskot',
    en: 'Final Report Grant',
  },

  'de-minimis-aid-v2': {
    nb: 'Erklæring om bagatellmessig støtte',
    nn: 'Fråsegn om bagatellmessig støtte',
    en: 'Declaration of De Minimis Aid',
  },

  'maintenance-release-of-collateral': {
    en: 'Release of collaterals',
    nb: 'Frafall av sikkerheter',
    nn: 'Fråfall av sikkerheit',
  },

  'maintenance-amendment-of-terms': {
    nb: 'Endring av vilkår for lån/tilskudd',
    nn: 'Endring av vilkår for lån/tilskot',
    en: 'Change of terms for loan/grant',
  },

  'maintenance-priority-deviation': {
    nb: 'Prioritetsvikelse',
    nn: 'Prioritetsviking',
    en: 'Priority deviation',
  },
} as const;
